import React from 'react';
import AuctionSwitcher from './components/AuctionSwitcher';
import FaqSection from './components/Faq';
import Statistics from './components/Statistics';
import AppDownloadSection from './components/AppDownloadSection';
import PartnersSectionNew from './components/OurPartnerNew';
import BannerNew from './components/Banner';
import { TodayAuction } from '../../components/AuctionsCategory/TodayAuction';
import { PreviousAuctionNew } from '../../components/AuctionsCategory/PreviousAuction';
import { MyAuctionsSection } from '../../components/AuctionsCategory/MyAuctions';
import { getAuctionChartData } from '../../../../models/auctions';
import { UpComingAuctionsNew } from '../../components/AuctionsCategory/UpComingAuctions';
import IsoCertificationSection from './components/IsoCertificationSection';

export class LandingPage extends React.Component {
  constructor(props) {
    // ← always pass props
    super(props); // ← always pass props
    const params = new URLSearchParams(window.location.search);
    this.state = {
      timeFilter: params.get('timeFilter') || 'all',
      counts: {},
      is_loading_1: false,
    };
    this.previousAuctionRef = React.createRef();
    this.upcomingAuctionRef = React.createRef();
    this.handleTimeFilterChange = this.handleTimeFilterChange.bind(this);
    // ❌ REMOVE this.loadAuctionsCount() from constructor
    //    Constructor runs before mount, and in React StrictMode
    //    it renders twice — causing 2 API calls
  }

  // ✅ Only call from componentDidMount — runs exactly once
  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadAuctionsCount(); // ← moved here

    const params = new URLSearchParams(window.location.search);
    const timeFilter = params.get('timeFilter');

    if (timeFilter === 'previous') {
      setTimeout(() => this.scrollToPrevious(), 600);
    }
    if (timeFilter === 'upcoming') {
      setTimeout(() => this.scrollToUpcoming(), 600);
    }
  }

  async loadAuctionsCount() {
    this.setState({ is_loading_1: true });
    try {
      const response = await getAuctionChartData('main');
      if (response?.data) {
        const data = response.data;
        this.setState({
          counts: {
            active: data.active,
            upcoming: data.upcoming,
            previous: data.previous,
            featured: data.featured,
            direct: data.direct,
            all: Number(data.previous) + Number(data.active),
          },
          is_loading_1: false,
        });
      } else {
        this.setState({ is_loading_1: false });
      }
    } catch (e) {
      console.error('loadAuctionsCount error:', e);
      this.setState({ is_loading_1: false });
    }
  }

  scrollToPrevious() {
    this.previousAuctionRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  scrollToUpcoming() {
    this.upcomingAuctionRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  handleTimeFilterChange(timeFilter) {
    this.setState({ timeFilter });

    const url = new URL(window.location);
    if (timeFilter && timeFilter !== 'all') {
      url.searchParams.set('timeFilter', timeFilter);
    } else {
      url.searchParams.delete('timeFilter');
    }
    window.history.replaceState({}, '', url);

    // ✅ Fixed: upcoming was calling scrollToPrevious by mistake
    if (timeFilter === 'previous') {
      setTimeout(() => this.scrollToPrevious(), 100);
    }
    if (timeFilter === 'upcoming') {
      setTimeout(() => this.scrollToUpcoming(), 100); // ← was scrollToPrevious, bug fixed
    }
  }

  render() {
    const { counts } = this.state;
    return (
      <div>
        <BannerNew />
        <AuctionSwitcher onTimeFilterChange={this.handleTimeFilterChange} counts={counts} />
        <MyAuctionsSection onTimeFilterChange={this.handleTimeFilterChange} counts={counts} />
        <TodayAuction onTimeFilterChange={this.handleTimeFilterChange} counts={counts} />

        {counts.upcoming > 0 && (
          <div ref={this.upcomingAuctionRef}>
            <UpComingAuctionsNew counts={counts} />
          </div>
        )}

        <div ref={this.previousAuctionRef}>
          <PreviousAuctionNew counts={counts} />
        </div>

        <IsoCertificationSection />
        <FaqSection />
        <Statistics />
        <PartnersSectionNew />
        <AppDownloadSection />
      </div>
    );
  }
}
